export const generateRemoteUrl = (searchQuery?: string) => {
  const params = new URLSearchParams();

  if (searchQuery) {
    params.append("search", searchQuery);
  }

  return `cursus${params.toString() ? `?${params.toString()}` : ""}`;
};
